import { NgModule } from '@angular/core';
import { provideBootstrapEffects } from '@innogy/utils-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule, combineReducers } from '@ngrx/store';

import { StoreOrderFormEffects } from './store';
import { StoreProductOverviewEffects } from './store/store-products/store-product-overview.effects';
import { storeReducers, storeSelectorKey } from './store/store-form.state';
import { StoreFunnelEffects } from './store/store-funnel/store-funnel.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(storeSelectorKey, combineReducers(storeReducers)),
    EffectsModule.forFeature([StoreProductOverviewEffects]),
  ],
  providers: [
    provideBootstrapEffects([StoreFunnelEffects, StoreOrderFormEffects]),
  ],
})
export class GenericStoreBootstrapModule {}
